import SimulateBaitChecker from 'components/baitchecker-inventory/simulator/SimulateBaitChecker';

const BaitCheckerSimulator = () => {
  return <SimulateBaitChecker />;
};

export default BaitCheckerSimulator;
